<!--
Author: TangChen
Date: 2018-09-12
Desc: 设置密码页面，为公共组件
 -->
<template>
    <div class="comp-set-num comp">
        <el-form
            ref="pwdForm"
            :model="pwdForm"
            :rules="rules"
            label-width="240px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item v-if="old" :label="'原' + text + '密码：'" prop="old">
                <el-input
                    v-model.trim="pwdForm.old"
                    :type="pwdType"
                    :placeholder="'请输入原' + text + '密码'"
                    :maxlength="16"
                >
                    <i
                        slot="suffix"
                        aria-hidden="true"
                        :class="iconCla"
                        v-on:click="pwdTypeChange"
                    />
                </el-input>
            </el-form-item>
            <el-form-item :label="'新' + text + '密码：'" prop="pwd">
                <el-input
                    v-model.trim="pwdForm.pwd"
                    :type="pwdType"
                    :placeholder="'请输入新' + text + '密码'"
                    :maxlength="16"
                >
                    <i
                        slot="suffix"
                        aria-hidden="true"
                        :class="iconCla"
                        v-on:click="pwdTypeChange"
                    />
                </el-input>
            </el-form-item>
            <el-form-item class="pwd-text">
                <div class="info" v-text="pwdText"></div>
            </el-form-item>
            <el-form-item :label="'确认' + text + '密码：'" prop="confirmPwd">
                <el-input
                    v-model.trim="pwdForm.confirmPwd"
                    :type="pwdType"
                    :placeholder="'请再输入一次' + text + '密码'"
                    :maxlength="16"
                >
                    <i
                        slot="suffix"
                        aria-hidden="true"
                        :class="iconCla"
                        v-on:click="pwdTypeChange"
                    />
                </el-input>
            </el-form-item>
            <el-form-item>
                <div class="btn-group">
                    <el-button
                        type="primary"
                        class="medium"
                        :disabled="btnLock"
                        v-on:click="submitForm('pwdForm')"
                    >
                        {{ btn1 }}
                    </el-button>
                    <el-button class="medium" :disabled="btnLock" v-on:click="back">
                        {{ btn2 }}
                    </el-button>
                </div>
            </el-form-item>
        </el-form>
        <agreement v-model="protocol" :data="agrType" v-on:all-read="agreePro"></agreement>
    </div>
</template>
<script>
import agreement from "@/components/form/agreement.vue";
import userApi from "@/api/user";
export default {
    name: "SetNum",
    components: {
        agreement
    },
    props: {
        pwdCon: {
            type: Object,
            default: function () {
                return { btnLock: false };
            }
        },
        proto: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            pwdType: "password",
            pwdText: "",
            old: false,
            agrType: "resettrade", // 协议类型，开户协议
            pwdForm: {
                old: "",
                pwd: "",
                confirmPwd: ""
            },
            protocol: false,
            btn1: "下一步",
            btn2: "返回",
            iconCla: "fa fa-eye-slash",
            text: "",
            btnLock: false, // 按钮状态
            rules: {
                old: [
                    { required: true, message: "请输入原密码", trigger: "blur" },
                    { validator: this.newPwdCheck, trigger: "blur" }
                ],
                pwd: [
                    { validator: this.validatePwd, trigger: "blur" },
                    { validator: this.oldAndNew, trigger: "blur" }
                ],
                confirmPwd: [
                    { validator: this.validatePwd, trigger: "blur" },
                    { validator: this.confirm, trigger: "blur" }
                ]
            }
        };
    },
    watch: {
        "pwdCon.btnLock"(val) {
            this.btnLock = val;
        }
    },
    created() {
        if (this.pwdCon) {
            this.old = this.pwdCon.oldpwd ? this.pwdCon.oldpwd : false;
            this.btn1 = this.pwdCon.btn1 ? this.pwdCon.btn1 : "下一步";
            this.btn2 = this.pwdCon.btn2 ? this.pwdCon.btn2 : "返回";
            this.text = this.pwdCon.text ? this.pwdCon.text : "";
            this.btnLock = this.pwdCon.btnLock;
        }
        // 交易密码和登录密码、查询密码规则不一致
        if (this.text.indexOf("交易") > -1) {
            this.pwdText = this.$util.initTPwdCheckText();
        } else if (this.text.indexOf("登录") > -1) {
            this.pwdText = this.$util.initPwdCheckText();
        } else {
            this.pwdText = this.$util.initQryPwdCheckText();
        }
    },
    methods: {
        /* 新密码校验 */
        newPwdCheck(rule, value, callback) {
            if (this.pwdForm.pwd !== "") {
                this.$refs["pwdForm"].validateField("pwd");
            }
            callback();
        },
        agreePro(val) {
            this.protocol = false;
            if (!val) return;
            this.$emit("pwd-get", true, this.pwdForm);
        },
        /* 确认密码校验 */
        confirm(rule, value, callback) {
            if (this.pwdForm.pwd !== this.pwdForm.confirmPwd) {
                callback(new Error("输入密码和确认密码不一致"));
            } else {
                callback();
            }
        },
        validatePwd(rule, value, callback) {
            if (this.text.indexOf("交易") > -1) {
                // 交易密码和登录密码规则不一致
                this.$util.validateTPwd(rule, value, callback);
            } else if (this.text.indexOf("登录") > -1) {
                this.$util.validatePwd(rule, value, callback);
            } else {
                this.$util.validateQryPwd(rule, value, callback);
            }
        },
        /* 新老密码校验 */
        oldAndNew(rule, value, callback) {
            if (this.pwdForm.pwd === this.pwdForm.old && this.pwdForm.pwd !== "") {
                callback(new Error("原密码和新密码不能相同"));
            } else {
                if (this.pwdForm.confirmPwd !== "") {
                    this.$refs["pwdForm"].validateField("confirmPwd");
                }
                callback();
            }
        },
        /* 密码显示或隐藏处理 */
        pwdTypeChange() {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        },
        /* 提交表单数据 */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.protocol = true;
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 回退到鉴权界面 */
        back() {
            this.$emit("pwd-get", false);
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-set-num {
    padding-bottom: 100px;
    .el-form-item.is-required .el-form-item__label:before {
        content: "";
    }
    .el-input,
    .btn-group {
        width: 50%;
        .el-button--default {
            float: right;
        }
        input {
            ime-mode: disabled;
        }
    }
}
.pwd-text {
    margin-bottom: 0px;
    color: $text-color3;
    .el-form-item__content {
        line-height: 24px;
        .info {
            margin: -16px 0 16px 0;
        }
    }
}
</style>
